import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    api(`/vehicles`).then(r => r.json()).then(setVehicles).catch(() => {});
  }, []);

  const filtered = vehicles.filter(v =>
    `${v.year} ${v.make} ${v.model} ${v.vin || ''}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const total = vehicles.length;
  const active = vehicles.filter(v => v.status === 'Active').length;
  const inService = vehicles.filter(v => v.status === 'In Service').length;

  const stats = [
    { title: 'Total Vehicles', value: total },
    { title: 'Active', value: active },
    { title: 'In Service', value: inService },
  ];

  return (
    <Layout>
      <div className="hidden md:grid grid-cols-3 gap-6 mb-6">
        {stats.map((stat) => (
          <div key={stat.title} className="bg-white rounded-lg shadow p-6">
            <p className="text-sm text-gray-500 mb-1">{stat.title}</p>
            <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Vehicles</h1>
            <Link to="/vehicles/new" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">
              Add Vehicle
            </Link>
          </div>
          <input
            type="text"
            placeholder="Search by year, make, model, or VIN..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vehicle</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Color</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Mileage</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((v) => (
                <tr key={v.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    <Link to={`/vehicles/${v.id}`} className="text-purple-600 hover:text-purple-800">{v.year} {v.make} {v.model}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{v.color}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600">{v.mileage?.toLocaleString()}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      v.status === 'Active' ? 'bg-green-100 text-green-800' :
                      v.status === 'In Service' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {v.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="text-center py-12 text-gray-500">No vehicles found.</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
